import {
  Family,
  Adminstrator,
  Investment,
  Assoociate,
  Provider,
  Seller,
} from "../Rolle";
import { isAuthenticated } from "../../auth";

const toId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (value?._id) return String(value._id);
  return String(value);
};

const hasStarted = (startDate, referenceDate = new Date()) => {
  if (!startDate) return false;
  const start = new Date(startDate);
  if (Number.isNaN(start.getTime())) return false;
  return referenceDate >= start;
};

const isPublicAccessOpen = (projectVisibilityAccess = {}, referenceDate = new Date()) => {
  const publicAccess = projectVisibilityAccess.publicAccess || {};
  if (!publicAccess.enabled || !publicAccess.startDate) return false;

  const startDate = new Date(publicAccess.startDate);
  if (Number.isNaN(startDate.getTime())) return false;
  return referenceDate >= startDate;
};

const didInvestInProject = (investments = [], projectId) => {
  const sourceProjectId = toId(projectId);
  if (!sourceProjectId) return false;

  return investments.some((investment) => {
    const investmentProjectId = toId(
      investment?._idInvestment ||
        investment?._idIvestement ||
        investment?.projectId ||
        investment?.project?._id
    );
    return investmentProjectId === sourceProjectId;
  });
};

const canVipAccessProject = (project = {}, projectVisibilityAccess = {}) => {
  const accessList = Array.isArray(projectVisibilityAccess.listProjectAccess)
    ? projectVisibilityAccess.listProjectAccess.map(toId).filter(Boolean)
    : [];

  if (accessList.length === 0) return true;

  const currentProjectId = toId(project?._id || project?.id);
  return accessList.includes(currentProjectId);
};

const GROUP_ACCESS_RANK = {
  family_group: 0,
  administrator_group: 1,
  vip_investors: 2,
  investors_elakay_group: 3,
  associate_group: 4,
  provider_group: 5,
  seller_group: 6,
};

const getStartedAccessSteps = (accessSteps = [], referenceDate = new Date()) =>
  accessSteps.filter((step) => step?.active === true && hasStarted(step.startDate, referenceDate));

const canHigherGroupUseStartedStep = (userGroupKey, startedStep) => {
  const userRank = GROUP_ACCESS_RANK[userGroupKey];
  const stepRank = GROUP_ACCESS_RANK[startedStep?.groupKey];
  if (typeof userRank !== "number" || typeof stepRank !== "number") return false;
  return userRank <= stepRank;
};

export const canViewInvestmentProject = ({
  project = {},
  projectVisibilityAccess,
  investments = [],
}) => {
  try {
    const access = projectVisibilityAccess || project.projectVisibilityAccess || {};

    if (access.enabled === false || !access.enabled) return true;

    const accessSteps = Array.isArray(access.accessSteps) ? access.accessSteps : [];
    if (accessSteps.length === 0) return true;

    const today = new Date();

    if (isPublicAccessOpen(access, today)) return true;

    const allDeadlinesExpired = accessSteps.every((step) => {
      if (!step?.deadline) return false;
      const deadline = new Date(step.deadline);
      return !Number.isNaN(deadline.getTime()) && today > deadline;
    });

    if (allDeadlinesExpired) return true;

    if (!isAuthenticated()) return false;

    if (Family()) return true;

    const startedSteps = getStartedAccessSteps(accessSteps, today);
    if (startedSteps.length === 0) return false;

    const vipProjectId = toId(access.idProjectToBeVIP);
    const isVipInvestor = didInvestInProject(investments, vipProjectId);
    const userGroupKeys = [
      Adminstrator(true) ? "administrator_group" : null,
      isVipInvestor && canVipAccessProject(project, access) ? "vip_investors" : null,
      Investment(true) ? "investors_elakay_group" : null,
      Assoociate(true) ? "associate_group" : null,
      Provider(true) ? "provider_group" : null,
      Seller(true) ? "seller_group" : null,
    ].filter(Boolean);

    const stepAllowsUser = userGroupKeys.some((groupKey) =>
      startedSteps.some((step) => canHigherGroupUseStartedStep(groupKey, step))
    );

    if (stepAllowsUser) return true;

    return false;
  } catch (error) {
    console.error("canViewInvestmentProject", error);
    return false;
  }
};

export default canViewInvestmentProject;
